// this is a helper function to find the correct digistyleId, because the backend objects use different property names

export default function findCorrectDigistyleId (item) {
    if (item.productId) {
        return item.productId;
    }
    if(item.digistyleId) {
        return item.digistyleId;
    }
    else {
        return item.id;
    }
}